import Image from 'next/image';
import cn from 'classnames';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const ChatHighlight = ({ time, chat, updatePlayerTime }) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time) - minutes * 60;
  const formatMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formatSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return (
    <div className="max-w-[1008px] mx-auto text-center">
      <button
        onClick={() => updatePlayerTime(time)}
        className="hidden lg:block text-center mx-auto outline-none hover:underline focus:underline"
        type="button"
      >
        {formatMinutes}:{formatSeconds}
      </button>
      <div className="flex flex-col space-y-9 mt-8">
        {chat.map(({ author, text }, idx) => {
          const isAnswer = idx % 2 !== 0;

          return (
            <div
              className={cn('flex flex-col text-left', {
                'lg:flex-row-reverse': isAnswer,
                'lg:flex-row': !isAnswer
              })}
              key={text}
            >
              <div
                className={cn('min-w-max', { 'lg:mr-8': !isAnswer, 'lg:ml-8': isAnswer })}
                title={author.name}
              >
                <Image
                  className="rounded-full bg-transform-gradient-vertical"
                  src={author.avatar}
                  width="72"
                  height="72"
                />
              </div>
              <div className="relative py-6 px-8 mt-6 lg:mt-0 rounded-lg bg-codGray max-w-[800px]">
                <svg
                  className={cn('hidden lg:block absolute top-6', {
                    '-left-2': !isAnswer,
                    '-right-2 transform rotate-180': isAnswer
                  })}
                  width="11"
                  height="24"
                  viewBox="0 0 11 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M-5.68248e-07 12L10.5 0.741668L10.5 23.2583L-5.68248e-07 12Z"
                    fill="#171717"
                  />
                </svg>
                <ReactMarkdown rehypePlugins={[rehypeRaw]}>{text}</ReactMarkdown>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChatHighlight;
